import React, { useState } from "react";
import authLogo from "../../../assets/auth_logo.png";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { Spinner } from "react-bootstrap";
import * as Yup from "yup";
import { usePostLoginMutation } from "../../../rtk-query/slices/auth/authSlice";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useGetUserProfileQuery } from "../../../rtk-query/slices/profile/profileSlice";
function LoginCard() {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [postLogin, { isLoading }] = usePostLoginMutation();
  const {
    refetch,
    data: userData,
    fetching: isUserDataFetching,
    loading: isUserDataLoading,
  } = useGetUserProfileQuery();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values, { resetForm, setFieldError }) => {
      try {
        localStorage.removeItem("DODAdminCreatedBy");
        const data = {
          email: values.email,
          password: values.password,
        };
        const response = await postLogin(data);

        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          localStorage.setItem("DODLoginToken", response?.data?.token);
          const userDataResponse = await refetch();
          resetForm(); // Clear the form

          if (
            response?.data?.is_verified === 0 ||
            response?.data?.is_verified === null
          ) {
            if (userDataResponse?.data?.data?.supplier?.on_boardings < 4) {
              localStorage.setItem("DODUserEmailToVerifyNext", "onboarding"); // Clear the stored user email
            } else {
              localStorage.setItem("DODUserEmailToVerifyNext", "products"); // Clear the stored user email
            }

            localStorage.setItem(
              "DODUserEmailToVerify",
              response?.data?.data?.supplier_user_email
            );
            navigate("/verify-token");
          } else {
            if (userDataResponse?.data?.data?.supplier?.on_boardings < 4) {
              navigate("/onboarding"); // Clear the stored user email
            } else {
              navigate("/products"); // Clear the stored user email
            }
          }

          // Redirect to the onboarding screen
        }
        if (response?.error) {
          const errors = response?.error?.data?.errors;
          if (errors) {
            for (const field in errors) {
              if (errors.hasOwnProperty(field)) {
                const combinedErrors = errors[field].join(" ");
                setFieldError(field, combinedErrors);
              }
            }
            toast.error(response?.error?.data.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            toast.error(response?.error?.data.message, {
              position: "top-center",
              autoClose: 3000,
            });
          }
        }
      } catch (error) {
        toast.error("An unexpected error occurred. Please try again.");
      }
    },
  });
  return (
    <div className="auth-card">
      <div className="auth-card-header d-flex align-items-center justify-content-center">
        <img src={authLogo} alt="logo" width={181} height={61} />
      </div>
      <div className="auth-card-body">
        {/* <h1 className="auth-card-heading mb-2">Welcome supplier login</h1>
        <p className="auth-card-description">
          Login and start creating products and grow your business 
        </p>*/}
        <form onSubmit={formik.handleSubmit} className="auth-card-form mt-3">
          {/* email input field */}
          <div className="auth-card-form-group d-flex flex-column align-items-start gap-1 mb-3">
            <label className="input-label" htmlFor="email">
              Email
            </label>
            <input
              className={`input-field ${
                formik.touched.email && formik.errors.email ? "is-invalid" : ""
              }`}
              type="email"
              disabled={isLoading}
              id="email"
              // placeholder="Email"
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="invalid-feedback">{formik.errors.email}</div>
            ) : null}
          </div>
          {/* password input field */}
          <div className="position-relative auth-card-form-group d-flex flex-column align-items-start gap-1 mt-3">
            <label className="input-label" htmlFor="password">
              Password
            </label>
            <input
              className={`input-field ${
                formik.touched.password && formik.errors.password
                  ? "is-invalid"
                  : ""
              }`}
              disabled={isLoading}
              type={showPassword ? "text" : "password"}
              id="password"
              // placeholder="Password"
              {...formik.getFieldProps("password")}
            />
            <p
              onClick={() => setShowPassword(!showPassword)}
              className="position-absolute input-field-toggle"
            >
              {showPassword ? "Hide" : "show"}
            </p>
            {formik.touched.password && formik.errors.password ? (
              <div className="invalid-feedback">{formik.errors.password}</div>
            ) : null}
          </div>
          {/* forgot password */}
          <div className="d-flex align-items-center justify-content-end mt-3">
            <Link to="/forgot-password" className="forgot-password-link">
              Forgot Your Password?
            </Link>
          </div>
          {/* login button */}
          <button
            type="submit"
            disabled={isLoading}
            className="w-100 auth-login-btn mt-3"
          >
            Login to your account{" "}
            {(isLoading || isUserDataFetching || isUserDataLoading) && (
              <Spinner size="sm" />
            )}
          </button>
          {/* terms and conditions */}
          <p className="auth-card-terms mt-4">
            By proceeding, you agree to the <span>Privacy Policy</span> and{" "}
            <span>Terms & Conditions</span>
          </p>
        </form>
      </div>
      <div className="auth-card-footer pt-3 pb-3">
        <p>
          Do not have an account? <Link to="/signup">Create Now</Link>
        </p>
      </div>
    </div>
  );
}

export default LoginCard;
